const encodeData = (data: { [key: string]: string }) => {
  return Object.keys(data)
    .map(key => [key, data[key]].map(encodeURIComponent).join('='))
    .join('&');
};

export default encodeData;
